import { NotificationsListRequestQuery } from '@repo/api/web/models'
import { injectable, inject } from 'inversify'

import { NotificationsService } from '../services'
import { useNotificationsStore } from '../store'

@injectable()
export class NotificationsSupport {
  protected store: ReturnType<typeof useNotificationsStore>

  constructor(
    @inject(NotificationsService) protected service: NotificationsService,
  ) {
    this.store = useNotificationsStore()
  }

  async loadUnreadCount() {
    const response = await this.service.list(
      NotificationsListRequestQuery.create({
        'Filter.Viewed': false,
        Limit: 0,
      }),
    )
    this.store.unreadCount = response.items?.length ?? 0
  }

  async markAsRead(id: number) {
    await this.service.markViewed(id)
  }

  async markAllAsRead() {
    await this.service.markAllViewed()
    await this.loadUnreadCount()
  }
}
